import {preloadImg, setUrlParameter} from "../utils/shared";

export const gridMixin = {
    data() {
        return {}
    },
    methods: {
        $_calculateGrid(arr) {
            let fullRowsCnt = Math.floor(arr.length / this.gridSize)
            this.$_lastFullRowMediaIdx = fullRowsCnt * this.gridSize;
        },
        $_getGridClasses(index) {
            if (this.gridSize === 5) {
                return {'videoList-4': index % this.gridSize === 0 && index < this.$_lastFullRowMediaIdx}
            }

            return {}
        }
    }
}

export const preloadMediasMixin = {
    data() {
        return {}
    },
    methods: {
        $_preloadMedias(medias) {
            //debugger
            let promises = medias.map((media) => {
                return preloadImg(media.thumbs.large.url)
                    .then(() => {
                        this.$store.commit(this.storeModule + '/setLoadedMedia', media)
                    })

            })

            return Promise.all(promises)
                .then(() => {
                    medias.map((media) => {
                        //this.$store.commit(this.storeModule + '/setLoadedMedia', media)
                    })
                })
        }
    }
}

export const preloadNewsMixin = {
    data() {
        return {}
    },
    methods: {
        $_preloadNews(news) {
            //debugger
            let newNews = news.filter((news_) => {
                return !news_._loaded
            })

            let promises = newNews.map((news_) => {
                //let src = this.$_cover(news_)
                //debugger
                let src = news_.cover

                if (src.length) {
                    // TODO replace image-src in rendered content
                    return preloadImg(src)
                        .then(() => {
                            //this.$store.commit('news/setLoadedNews', news_)
                        })
                }
            })

            return Promise.all(promises)
                .finally(() => {
                    newNews.map((news_) => {
                        this.$store.commit('news/setLoadedNews', news_)
                    })
                })
        },
    }
}

